import { render, staticRenderFns } from "./addModule.vue?vue&type=template&id=c2e12cd8&scoped=true"
import script from "./addModule.vue?vue&type=script&lang=js"
export * from "./addModule.vue?vue&type=script&lang=js"
import style0 from "./addModule.vue?vue&type=style&index=0&id=c2e12cd8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e12cd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2e12cd8')) {
      api.createRecord('c2e12cd8', component.options)
    } else {
      api.reload('c2e12cd8', component.options)
    }
    module.hot.accept("./addModule.vue?vue&type=template&id=c2e12cd8&scoped=true", function () {
      api.rerender('c2e12cd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/customPage/components/addModule.vue"
export default component.exports